import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { CreateView } from './Create';
import { EditView } from './Edit';
import { OverviewView } from './Overview';

export class StandardStrategiesView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Switch>
                <Route exact path="/a/strategies/standard" component={OverviewView} />
                <Route exact path="/a/strategies/standard/new" component={CreateView} />
                <Route exact path="/a/strategies/standard/:id" component={EditView} />
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/index.js